import * as Scrivito from "scrivito"

export const FeatureOverviewWidget = Scrivito.provideWidgetClass(
  "FeatureOverviewWidget",
  {
    attributes: {
      title: ["widgetlist", { only: ["TextWidget"], maximum: 1 }],
      subtitle: ["widgetlist", { only: ["TextWidget"], maximum: 1 }],
      items: ["widgetlist", { only: ["FeatureOverviewItemWidget"], maximum: 8 }]
    }
  }
)
